import axios from 'axios';
import { TYPE } from './types';
import * as Constants from '../../constants';

import { validateReqBodyFn, requestHeadersKeyValues } from "./validateRequestBodyFn";

// Refreshes the cached auth data so hotels linked/unlinked after login show up
// without re-login. Skips the write when nothing changed, and falls back to the
// first hotel if the previously selected one is no longer linked to this user.
function updateLocalUserData(userData) {
    try {
        // console.warn is used because console.log is disabled when debug = 0
        const serializedUserData = JSON.stringify(userData)
        console.warn("__authHotelsRefresh__ hotels in auth response:", userData.hotels ? userData.hotels.length : "none")
        const previousUserData = localStorage.getItem(Constants.USER_DATA)
        if (previousUserData !== serializedUserData) {
            try {
                localStorage.setItem(Constants.USER_DATA, serializedUserData)
            } catch (writeError) {
                // Quota errors: free the old value first, then retry once.
                // If the retry also fails, restore the previous value so the
                // session token is never lost (losing it would log the user out).
                try {
                    localStorage.removeItem(Constants.USER_DATA)
                    localStorage.setItem(Constants.USER_DATA, serializedUserData)
                } catch (retryError) {
                    if (previousUserData !== null) {
                        localStorage.setItem(Constants.USER_DATA, previousUserData)
                    }
                    throw retryError
                }
            }
            console.warn("__authHotelsRefresh__ user_data updated in localStorage")
        }

        if (userData.hotels && userData.hotels.length > 0) {
            const selectedHotel = userData.hotels.find(
                hotel => hotel.hotel_id === localStorage.getItem(Constants.SELECTED_HOTEL_ID)
            )
            if (selectedHotel === undefined) {
                localStorage.setItem(Constants.SELECTED_HOTEL_ID, userData.hotels[0].hotel_id)
                localStorage.setItem(Constants.SELECTED_HOTEL_NAME, userData.hotels[0].hotel_name)
            }
            else if (selectedHotel.hotel_name !== localStorage.getItem(Constants.SELECTED_HOTEL_NAME)) {
                localStorage.setItem(Constants.SELECTED_HOTEL_NAME, selectedHotel.hotel_name)
            }
        }
    } catch (error) {
        console.error("__updateLocalUserDataError__", error)
    }
}

export function checkSessionStatus(data) {
    let apiToken = JSON.parse(localStorage.getItem(Constants.USER_DATA)).token;
    const authApi = Constants.HOTEL_API + '/' + TYPE.AUTH;
    const request = axios
        .post(authApi, validateReqBodyFn(data), {
            headers: requestHeadersKeyValues()
        })
        .then(response => {
            if (response.data.status === "SUCCESS" && response.data.data.token && response.data.data.token.length > 20) {
                updateLocalUserData(response.data.data)
                response.data.selectedHotelID = localStorage.getItem(Constants.SELECTED_HOTEL_ID)
                response.data.selectedHotelName = localStorage.getItem(Constants.SELECTED_HOTEL_NAME)
                response.data.isSessionValid = true
                if (response.data.data.hotels !== undefined) {
                    let hotelDetailsObj = response.data.data.hotels.filter((item) => item.hotel_id === localStorage.getItem(Constants.SELECTED_HOTEL_ID))
                    if (hotelDetailsObj[0] !== undefined) {
                        response.data.hotelDetailObj = hotelDetailsObj[0]
                    }
                }
            } else {
                response.data.isSessionValid = false
            }

            return response.data;
        });
    return {
        type: TYPE.AUTH,
        payload: request
    }
}

export function clearSession() {
    localStorage.clear();
    let response = Object();
    response.data = Object();
    response.data.isSessionValid = false
    return {
        type: TYPE.CLEAR_SESSION,
        payload: response
    }
}

